import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './styles/tailwind.css';
import { Toaster, toast } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { BadResponse } from './types/response';
import keycloak from './config/keycloak';
import { registerServiceWorker } from './pwa/serviceWorker';

registerServiceWorker();

window.onerror = function (message) {
  toast.error(`Ошибка: ${message}`);
};
window.onunhandledrejection = function (event) {
  toast.error(`Ошибка: ${event.reason}`);
};

const onError = (error: Error | AxiosError<BadResponse>) => {
  let errorMessage = 'Произошла ошибка при запросе. Попробуйте позже.';

  if (error instanceof AxiosError) {
    if ((error.response?.status || -1) >= 400 && (error.response?.status || -1) < 500) {
      if (error?.response?.status === 401) {
        keycloak.logout();
        errorMessage = 'Ошибка авторизации';
      } else {
        errorMessage =
          error.response?.data?.message || 'Ошибка клиента. Проверьте запрос или ресурс.';
      }
    } else {
      errorMessage =
        'Возникли технические проблемы. Попробуйте обновить страницу или вернуться чуть позже. Если проблема сохраняется, обратитесь в Сервис Деск компании.';
    }
  }

  toast.error(errorMessage);
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: 'always',
      retry: 2,
    },
  },
  queryCache: new QueryCache({
    onError: onError,
  }),
  mutationCache: new MutationCache({
    onError: onError,
  }),
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <ErrorBoundary>
    <Toaster position="top-right" />
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </ErrorBoundary>,
);
